import { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { Loader2, Lock, Sparkles } from "lucide-react";
import { useAuth } from "../../context/AuthContext";
import { formatApiErrorDetail } from "../../lib/api";
import { Input } from "../../components/ui/input";
import { Label } from "../../components/ui/label";
import { Button } from "../../components/ui/button";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  if (user && user.role) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      navigate("/admin");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen grid place-items-center bg-navy grain px-5" data-testid="admin-login-page">
      <div className="relative w-full max-w-md rounded-3xl bg-white p-8 lg:p-10 shadow-2xl">
        <div className="flex items-center gap-2.5 mb-8">
          <span className="grid place-items-center w-9 h-9 rounded-lg bg-navy text-white">
            <Sparkles className="w-5 h-5" />
          </span>
          <span className="font-heading font-extrabold text-navy tracking-tight">Mark Clean Admin</span>
        </div>
        <h1 className="font-heading font-extrabold text-navy text-3xl tracking-tighter">Staff Login</h1>
        <p className="mt-2 text-muted-foreground text-sm">Sign in to view bookings and enquiries.</p>

        <form onSubmit={submit} className="mt-8 space-y-5" data-testid="admin-login-form">
          <div className="space-y-2">
            <Label className="text-sm font-medium text-navy">Email</Label>
            <Input data-testid="admin-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="admin@markcleanservices.co.uk" className="h-12" />
          </div>
          <div className="space-y-2">
            <Label className="text-sm font-medium text-navy">Password</Label>
            <Input data-testid="admin-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="••••••••" className="h-12" />
          </div>
          {error && <p className="text-sm text-destructive" data-testid="admin-login-error">{error}</p>}
          <Button type="submit" disabled={loading} data-testid="admin-login-submit" className="w-full rounded-full bg-brandgreen hover:bg-navy h-12 font-semibold">
            {loading ? <><Loader2 className="w-4 h-4 mr-2 animate-spin" /> Signing in...</> : <><Lock className="w-4 h-4 mr-2" /> Sign In</>}
          </Button>
        </form>
      </div>
    </div>
  );
}
